/* ============================================
   QN-NEW HERO SLIDER JS (Quiero Natural)
   Slide horizontal tipo "empuje" con loop continuo
   (clones para salto fin<->inicio invisible),
   flechas al hover, dots, autoplay, swipe tactil
   y animacion de contenido por slide.
   ============================================ */

(function () {
  'use strict';

  function animateContent(slideEl) {
    if (!slideEl) return;
    var els = slideEl.querySelectorAll('[data-animate]');
    Array.prototype.forEach.call(els, function (el) {
      el.style.animation = 'none';
      // trigger reflow
      void el.offsetHeight;
      var type = el.dataset.animate || 'fadeInUp';
      var delay = el.dataset.delay || 0;
      el.style.animation = 'qn-hero-' + type + ' 0.7s ease forwards';
      el.style.animationDelay = delay + 'ms';
    });
  }

  function initSlider(root) {
    if (!root || root.dataset.qnhInit === '1') return;

    var track = root.querySelector('[data-track]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
    var n = slides.length;
    if (n === 0) return;

    root.dataset.qnhInit = '1';

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slide-dot]'));
    var prevBtn = root.querySelector('[data-slider-prev]');
    var nextBtn = root.querySelector('[data-slider-next]');
    var autoplay = root.dataset.autoplay === 'true';
    var speed = parseInt(root.dataset.speed, 10) || 5000;
    var DURATION = 600;
    var TRANSITION = 'transform ' + DURATION + 'ms cubic-bezier(.22,.61,.36,1)';

    if (n === 1) {
      animateContent(slides[0]);
      return;
    }

    // Clones para loop continuo
    var firstClone = slides[0].cloneNode(true);
    var lastClone = slides[n - 1].cloneNode(true);
    [firstClone, lastClone].forEach(function (c) {
      c.setAttribute('aria-hidden', 'true');
      c.dataset.clone = '1';
    });
    track.insertBefore(lastClone, slides[0]);
    track.appendChild(firstClone);

    var pos = 1;
    var timer = null;

    function logical() { return ((pos - 1) % n + n) % n; }

    function setX(animate) {
      track.style.transition = animate ? TRANSITION : 'none';
      track.style.transform = 'translate3d(' + (-pos * 100) + '%,0,0)';
      if (!animate) void track.offsetHeight;
    }

    function updateDots() {
      var l = logical();
      dots.forEach(function (d, i) { d.classList.toggle('qn-hero__dot--active', i === l); });
    }

    function go(delta) { pos += delta; setX(true); updateDots(); }
    function goToLogical(i) { pos = i + 1; setX(true); updateDots(); }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track) return;
      if (pos === 0) { pos = n; setX(false); }
      else if (pos === n + 1) { pos = 1; setX(false); }
      animateContent(track.children[pos]);
    });

    function start() {
      if (!autoplay) return;
      stop();
      timer = window.setInterval(function () { go(1); }, speed);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); stop(); go(-1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); stop(); go(1); start(); });

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { stop(); goToLogical(i); start(); });
    });

    // Swipe tactil (sin drag de mouse para no romper botones/links del hero)
    var startX = 0, dx = 0, dragging = false;
    root.addEventListener('touchstart', function (e) {
      stop();
      dragging = true;
      startX = e.changedTouches[0].clientX;
      dx = 0;
      track.style.transition = 'none';
    }, { passive: true });

    root.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      dx = e.changedTouches[0].clientX - startX;
      var percent = (dx / root.clientWidth) * 100;
      track.style.transform = 'translate3d(' + (-(pos * 100 - percent)) + '%,0,0)';
    }, { passive: true });

    root.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      var t = root.clientWidth * 0.12;
      if (dx > t) go(-1);
      else if (dx < -t) go(1);
      else setX(true);
      start();
    }, { passive: true });

    // Pausa en hover y al ocultar pestania
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    setX(false);
    updateDots();
    animateContent(track.children[pos]);
    start();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-section-type="hero-slider"]');
    Array.prototype.forEach.call(roots, initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-section-type="hero-slider"]');
    if (root) initSlider(root);
  });
})();
